import { isSubmitted, tabApply, tabDining, tabProfile, tabSix } from '@romain130492/topchopsticks'
import { useI18n } from '../hooks/useI18n'
import { useSession } from '../hooks/useSession'

export type TabKey = 'apply' | 'dining' | 'six' | 'profile'

// The SAME artwork the mini program uses — shared data URIs, not lookalikes.
const TABS: Array<{ key: TabKey; label: string; icon: string }> = [
  { key: 'apply', label: 'nav.apply', icon: tabApply },
  { key: 'dining', label: 'nav.dining', icon: tabDining },
  { key: 'six', label: 'nav.six', icon: tabSix },
  { key: 'profile', label: 'nav.profile', icon: tabProfile }
]

/**
 * WHICH TABS EXIST IS THIS COMPONENT'S JOB.
 *
 * Apply is only for people who have not applied yet. In the mini program that
 * arrived as a `hideApply` prop computed in one page, so every OTHER screen
 * fell back to the default and showed Apply to members who had already
 * applied. The bar asks for itself here, so it cannot disagree with anyone.
 */
export default function TabBar({ active, onTab }: { active: TabKey; onTab: (tab: TabKey) => void }) {
  const { t } = useI18n()
  const { application } = useSession()
  const tabs = isSubmitted(application) ? TABS.filter((tab) => tab.key !== 'apply') : TABS

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 mx-auto flex max-w-app border-t border-gold-dim bg-bg"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onTab(tab.key)}
          className={`flex flex-1 flex-col items-center gap-1 pb-3 pt-2.5 text-2xs tracking-[0.04em] ${
            active === tab.key ? 'text-gold' : 'text-muted-2'
          }`}
        >
          {/* 20px, 0.42 opacity when inactive — the mini program's values. */}
          <img src={tab.icon} alt="" className={`h-5 w-5 ${active === tab.key ? '' : 'opacity-[0.42]'}`} />
          {t(tab.label)}
        </button>
      ))}
    </nav>
  )
}
